/*
 *   File : kyc-status.js
 *   Author : https://evoqins.com
 *   Description : kyc status modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/


import React from 'react';
import { useNavigate } from 'react-router-dom';

//custom component
import { PrimaryButton } from '../Buttons';

//Assets
import Close from "../../Assets/Images/close-btn-white.svg";

const KycStatusModal = (props) => {

    const navigate = useNavigate();

    // //handle to navigate home
    // const _handleNavigate = () => {
    //     navigate("/");
    // };


    // // handle close modal 
    // const _handleModalClose = () => {
    //     props.onCloseModal();
    // };

    return (
        <div className="modal fade"
            data-bs-backdrop="static"
            id="kyc-status-modal"
            tabIndex="-1"
            aria-labelledby="kycStatusModalLabel"
            aria-hidden="true">
            <div className="modal-dialog  modal-dialog-centered modal-md " >
                <div className="modal-content e-bg-blur-gradient e-border-radius-24 e-addbank-box-shadow">
                    <button id='kyc-status-modal-close-btn' data-bs-dismiss="modal" className='d-none'></button>
                    <div className="modal-header border-0 justify-content-end pt-4 pb-0 px-4 ">
                        <img src={Close}
                            id='kyc-status-modal-close'
                            draggable={false}
                            className='cursor-pointer'
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            alt='close'
                            onClick={props.onCloseModal}
                        />
                    </div>
                    <div className="modal-body text-center p-4 ">
                        <img src={props.image}
                            draggable={false}
                            className='col-5'
                            alt='bank' />
                        <p className='mb-2 pt-4 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                            {props.title}
                        </p>
                        <p className='mb-0 px-md-4 px-sm-0 px-0 e-text-dark-liver e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px'>
                            {props.description}
                        </p>

                        <div className='padding-40px-top'>
                            <PrimaryButton name={props.buttonName}
                                className="padding-12px-top padding-12px-bottom col-8 e-font-14"
                                dismiss={props.type == 2 ? "modal" : ""}
                                onPress={props.onButtonClick} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default KycStatusModal